import * as selectors from './auth-selectors';
import { useAuthStore } from './auth-store';

export const useSelectCanShowSuccessMessage = () =>
  useAuthStore(selectors.selectCanShowSuccessMessage);

export const useSelectChangePasswordError = () => useAuthStore(selectors.selectChangePasswordError);

export const useSelectForgotPasswordError = () => useAuthStore(selectors.selectForgotPasswordError);

export const useSelectHasChangePasswordError = () =>
  useAuthStore(selectors.selectHasChangePasswordError);

export const useSelectHasLoginError = () => useAuthStore(selectors.selectHasLoginError);

export const useSelectHasRegistrationError = () =>
  useAuthStore(selectors.selectHasRegistrationError);

export const useSelectHasResetPasswordError = () =>
  useAuthStore(selectors.selectHasResetPasswordError);

export const useSelectIsChangePasswordSuccess = () =>
  useAuthStore(selectors.selectIsChangePasswordSuccess);

export const useSelectIsForgotPasswordSuccess = () =>
  useAuthStore(selectors.selectIsForgotPasswordSuccess);

export const useSelectIsLogged = () => useAuthStore(selectors.selectIsLogged);

export const useSelectIsLoginPending = () => useAuthStore(selectors.selectIsLoginPending);

export const useSelectIsLoginRejected = () => useAuthStore(selectors.selectIsLoginRejected);

export const useSelectIsNotLogged = () => useAuthStore(selectors.selectIsNotLogged);

export const useSelectIsRegistrationSuccess = () =>
  useAuthStore(selectors.selectIsRegistrationSuccess);

export const useSelectLoginError = () => useAuthStore(selectors.selectLoginError);

export const useSelectLoginState = () => useAuthStore(selectors.selectLoginState);

export const useSelectRegistrationError = () => useAuthStore(selectors.selectRegistrationError);

export const useSelectResetPasswordError = () => useAuthStore(selectors.selectResetPasswordError);
